import React from 'react';
import { sendAction } from '@helpers/datadog-rum';

interface UppyErrorBoundaryState {
  hasError: boolean;
  errorMessage: string | null;
}

interface UppyErrorBoundaryProps {
  children: React.ReactNode;
}

export class UppyErrorBoundary extends React.Component<UppyErrorBoundaryProps, UppyErrorBoundaryState> {
  constructor(props: UppyErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, errorMessage: null };
  }

  static getDerivedStateFromError(error: Error): UppyErrorBoundaryState {
    return { hasError: true, errorMessage: error?.message ?? null };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    sendAction('Uppy Upload Component Crashed', {
      tags: {},
      extra: {
        error_message: error?.message ?? null,
        component_stack: info?.componentStack ?? null,
      }
    });
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div>
          Upload failed unexpectedly. Please refresh the page and try again.
        </div>
      );
    }
    return this.props.children;
  }
}
